import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  get_product_processing,
  get_raw_material_orders,
  getCustomers,
  create_raw_material_order,
  getRawMaterials,
  get_raw_material_order_details,
  update_raw_material_order,
  delete_raw_material_order,
  edit_raw_material_order,
  create_product_payment,
  postGeneralData,
  UpdatePaymentComplete,
  Order_status_update,
  get_order_returnlist,
  getUnits
} from '../../../Utility/Api';
import { WarehouseContext } from "../../../Utility/UserContext";
import { getFormattedCurrentDate2, NaviGate, onReqCreatePayment } from "../../../Utility/function";
import PaymentModal from "../../Common/PaymentModal";
import { Deletemodel } from "../../Common/Functions";
import CashModal from "../SalesWindow/modal/CashModal";
import CashCardModal from "../SalesWindow/modal/CashCardModal";
import CardModal from "../SalesWindow/modal/CardModal";
import moment from 'moment';

const FormattedDateInput = ({ name, value, onChange, min, max, className }) => {
  return (
    <div className="position-relative w-100">
      <input
        type="date"
        name={name}
        value={value || ''}
        min={min}
        max={max}
        onChange={onChange}
        style={{
          opacity: 0,
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          cursor: 'pointer',
          zIndex: 10
        }}
      />
      <div className={`form-control d-flex align-items-center justify-content-between ${className || ''}`} style={{ cursor: 'pointer', minHeight: '38px' }}>
        <span className={value ? "text-dark font-medium" : "text-muted"}>
          {value ? (moment(value).isValid() ? moment(value).format('DD/MM/YYYY') : value) : 'DD/MM/YYYY'}
        </span>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-secondary">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
      </div>
    </div>
  );
};

const RawMaterialOrder = () => {
  const navigate = useNavigate();
  const { showLoader, hideLoader, UserItem, shopItem, selectedWarehouse, warehouse } = useContext(WarehouseContext);

  const [customers, setCustomers] = useState([]);
  const [globalReturns, setGlobalReturns] = useState([]);

  const getOrderReturnedAmount = (orderId, orderMasterId) => {
    let totalReturned = 0;
    const listToUse = Array.isArray(globalReturns) ? globalReturns : [];
    listToUse.forEach((ret) => {
      let retData = [];
      try {
        if (ret.return_data) {
          retData = JSON.parse(ret.return_data);
        } else if (ret.invoice_number) {
          retData = JSON.parse(ret.invoice_number);
        }
      } catch (e) { }

      if (Array.isArray(retData)) {
        retData.forEach((retItem) => {
          const isMatch =
            retItem.om_id == orderMasterId ||
            retItem.unique_id === orderId ||
            (ret.unique_id && ret.unique_id.includes(orderId));

          if (isMatch) {
            const qty = parseFloat(retItem.returnqty || retItem.qty || 0);
            const price = parseFloat(retItem.price || 0);
            const amt = parseFloat(retItem.amount || (qty * price) || 0);
            totalReturned += amt;
          }
        });
      }
    });
    return totalReturned;
  };
  const [products, setProducts] = useState([]);
  const [orderItems, setOrderItems] = useState([{ pd_id: '', qty: 1 }]);
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [ordersList, setOrdersList] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [newStatus, setNewStatus] = useState("");
  const [orderDetails, setOrderDetails] = useState(null);
  const [showOrderDetailsModal, setShowOrderDetailsModal] = useState(false);

  const [showPayModal, setShowPayModal] = useState(false);
  const [input, setInput] = useState("");
  const [cashShow, setCashShow] = useState(false);
  const [cardShow, setCardShow] = useState(false);
  const [cashCardShow, setCashCardShow] = useState(false);

  const [cashAmount, setCashAmount] = useState("");
  const [cardAmount, setCardAmount] = useState("");
  const [partialPaymentModal, setPartialPaymentModal] = useState(false);
  const [selectedPaymentItem, setSelectedPaymentItem] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [totalPages, setTotalPages] = useState(1);
  const [paymentData, setPaymentData] = useState({
    mop: "1",
    amount: 0,
    paid: 0,
    due: 0
  });
  const [showEditModal, setShowEditModal] = useState(false);
  const [editOrder, setEditOrder] = useState(null);
  const [editItems, setEditItems] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [taxPercent, setTaxPercent] = useState(0);
  const [unitsList, setUnitsList] = useState([]);



  const [orderData, setOrderData] = useState({
    admin_id: UserItem?.user_id || "",
    customer_id: "",
    purchase_unit: "2",
    user_id: UserItem?.user_id || "",
    shop_id: shopItem?.shop_id || "",
    warehouse_id: selectedWarehouse?.id || "",
    created_by: UserItem?.user_id || "",
    items: [],
    date: new Date().toISOString().split("T")[0]
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchCustomers();
    fetchProducts();
    fetchOrders();
    fetchUnitsList();
  }, []);

  const fetchUnitsList = async () => {
    try {
      const response = await getUnits();
      if (response.data && response.data.data) {
        setUnitsList(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching units:", error);
    }
  };

  const getUnitName = (unitId) => {
    if (!unitId) return "";
    const found = unitsList.find(u => String(u.id) === String(unitId));
    if (found) return found.title;
    if (String(unitId) === "1") return "kg";
    if (String(unitId) === "2") return "gram";
    if (String(unitId) === "3") return "ltr";
    if (String(unitId) === "4") return "ml";
    if (String(unitId) === "5") return "pcs";
    if (String(unitId) === "6") return "box";
    if (String(unitId) === "7") return "packet";
    return unitId;
  };

  const fetchOrders = async () => {
    showLoader();
    try {
      const params = {
        shop_id: shopItem?.shop_id || "",
        ware_id: selectedWarehouse?.id || "",
      };

      const [response, returnsRes] = await Promise.all([
        get_raw_material_orders(params),
        get_order_returnlist().catch(e => {
          console.error("Error fetching returns list in RawMaterialOrder:", e);
          return { data: { data: [] } };
        })
      ]);

      if (returnsRes.data && returnsRes.data.data) {
        setGlobalReturns(returnsRes.data.data);
      }

      if (response.data && response.data.data) {
        setOrdersList(response.data.data);
        setTotalPages(response.data.pagination?.total_pages || 1);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
      toast.error("Failed to fetch orders list");
    } finally {
      hideLoader();
    }
  };


  const handleCashChange = (e) => {
    const value = parseFloat(e.target.value || 0);
    const dueAmount = parseFloat(selectedPaymentItem?.remaining || selectedPaymentItem?.overall_price || 0);
    if (value + parseFloat(cardAmount || 0) > dueAmount) return;
    setCashAmount(value);
  };

  const handleCardChange = (e) => {
    const value = parseFloat(e.target.value || 0);
    const dueAmount = parseFloat(selectedPaymentItem?.remaining || selectedPaymentItem?.overall_price || 0);
    if (value + parseFloat(cashAmount || 0) > dueAmount) return;
    setCardAmount(value);
  };



  const handleProcessPartialPayment = async () => {
    try {
      showLoader();

      if (!selectedPaymentItem?.order_id) {
        toast.error("Invalid order details");
        hideLoader();
        return;
      }

      const dueAmount = parseFloat(selectedPaymentItem?.remaining || selectedPaymentItem?.overall_price || 0);
      const totalPayment = parseFloat(cashAmount || 0) + parseFloat(cardAmount || 0);
      const remainingAmount = dueAmount - totalPayment;

      const paydata = {
        orderID: selectedPaymentItem?.order_id,
        date: getFormattedCurrentDate2(),
        amount: "0",
        total_amount: selectedPaymentItem.overall_price || dueAmount.toFixed(3),
        cash: 0,
        credit: 0,
        card: 0,
        type: 2, // Sales type
        mop: "0",
        complete: "0",
      };

      if (cashAmount && cardAmount) {
        paydata.cash = cashAmount;
        paydata.card = cardAmount;
        paydata.mop = "1,4";
        if (remainingAmount <= 0) {
          paydata.complete = "1";
        }
      } else if (cashAmount) {
        paydata.cash = cashAmount;
        paydata.mop = "1";
        if (remainingAmount <= 0) {
          paydata.complete = "1";
        }
      } else if (cardAmount) {
        paydata.card = cardAmount;
        paydata.mop = "4";
        if (remainingAmount <= 0) {
          paydata.complete = "1";
        }
      }

      if (remainingAmount > 0) {
        paydata.credit = remainingAmount;
        paydata.mop = paydata.mop + ",2";
        paydata.complete = "0";
      }

      await onReqCreatePayment(paydata);

      if (totalPayment > 0) {
        const generalDataPayload1 = {
          type: "2",
          ref_id: selectedPaymentItem?.order_id,
          remarks: "Bank - From sales",
          date: getFormattedCurrentDate2(),
          created_by: UserItem?.user_id || "ADMIN1",
          shop_id: shopItem?.id || "0",
          amount: totalPayment.toString(),
          is_debit: "1",
        };
        await postGeneralData(generalDataPayload1);
      }

      if (paydata?.complete === "0" && remainingAmount > 0) {
        const generalDataCredit = {
          type: "8",
          ref_id: selectedPaymentItem?.order_id,
          remarks: "Sales Credit",
          date: getFormattedCurrentDate2(),
          created_by: UserItem?.user_id || "ADMIN1",
          shop_id: shopItem?.id || "0",
          amount: remainingAmount.toString(),
          is_debit: "1",
          profitloss: "",
        };
        await postGeneralData(generalDataCredit);
      } else if (paydata?.complete === "1") {
        const paymentCompleted = {
          type: "8",
          shop_id: shopItem?.id || "0",
          ref_id: selectedPaymentItem?.order_id,
        };
        await UpdatePaymentComplete(paymentCompleted);
      }

      toast.success("Payment processed successfully");
      await fetchOrders();
      setPartialPaymentModal(false);
      setCashAmount("");
      setCardAmount("");
      setSelectedPaymentItem(null);
      hideLoader();
    } catch (error) {
      console.error("Error processing payment:", error);
      toast.error("Error processing payment. Please try again.");
      hideLoader();
    }
  };


  const openPaymentModal = (order) => {
    setSelectedOrder(order);
    setSelectedPaymentItem(order);


    // if (order.payments_status === "0" || order.payments_status === "1") {
    //   setCashAmount("");
    //   setCardAmount("");
    //   setPartialPaymentModal(true);
    // }

    if (order.payments_status === "0") {
      setShowPayModal(true);
    } else if (order.payments_status === "1") {
      setCashAmount("");
      setCardAmount("");
      setPartialPaymentModal(true);
    }
  };

  function handleOpenPaymentModal(order) {
    setSelectedOrder(order);
    setSelectedPaymentItem(order);
    setShowPayModal(true);
  }

  const handleDeleteModal = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const handleDeleteOrder = async () => {
    showLoader();
    try {
      const res = await delete_raw_material_order(deleteId);
      if (res?.data && res.data.status === "success") {
        toast.success("Order deleted successfully");
        setShowDeleteModal(false);
        await fetchOrders();
      } else {
        toast.error(res?.data?.message || "Failed to delete order");
      }
    } catch (error) {
      console.error("Error deleting order:", error);
      toast.error(error?.response?.data?.message || "Error deleting order");
    } finally {
      hideLoader();
    }
  };

  const getProductStockDisplay = (prod) => {
    if (!prod) return "";
    const qty = parseFloat(prod.p_qty || 0);
    return `${qty.toFixed(2)} ${getUnitName(prod.pbox_unit)}`;
  };


  const fetchCustomers = async () => {
    showLoader();
    try {
      const response = await getCustomers();
      if (response.data && response.data.data) {
        setCustomers(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
      toast.error("Failed to fetch customers list");
    } finally {
      hideLoader();
    }
  };

  const fetchProducts = async () => {
    showLoader();
    try {
      const response = await getRawMaterials();
      if (response.data && response.data.data) {
        console.log("RAW MATERIALS LIST IN MODAL:", response.data.data);
        const mapped = response.data.data.map(item => ({
          id: item.id,
          product_title: item.title,
          p_qty: item.remaining_stock,
          pbox_unit: item.unit_id || "Kg",
          p_price: item.latest_price_unit || 0,
          p_weight: ""
        }));
        setProducts(mapped);
      }
    } catch (error) {
      console.error("Error fetching raw materials:", error);
      toast.error("Failed to fetch raw materials list");
    } finally {
      hideLoader();
    }
  };


  const handlePaymentType = (type) => {
    setShowPayModal(false);

    if (type == "1") {
      setCashShow(true);
      setInput("");
    } else if (type == "2") {
      handlePaymentSubmit(type);
    } else if (type == "4") { // Card
      setCardShow(true);
      setInput("");
    } else if (type == "5") { // Cash+Card
      setCashCardShow(true);
      setInput("");
    }
  };


  const handleClick = (value) => {
    setInput((prev) => {
      if (value === ".") {
        if (prev.includes(".") || prev === "") return prev;
      }
      return prev + value;
    });
  };

  const handleBackspace = () => {
    setInput((prev) => prev.slice(0, -1));
  };

  const getAmountDue = () => {
    if (!selectedOrder) return "0";
    const remaining = parseFloat(selectedOrder.remaining || 0);
    return remaining > 0 ? remaining.toFixed(3) : parseFloat(selectedOrder.overall_price || 0).toFixed(3);
  };

  const getReturnValue = () => {
    const amountDue = parseFloat(getAmountDue() || 0);
    if (amountDue <= 0) return amountDue.toFixed(3);

    return input &&
      !isNaN(input) &&
      /^\d+(\.\d{1,2})?$/.test(input) &&
      parseFloat(input) >= amountDue
      ? (parseFloat(input) - amountDue)?.toFixed(3)
      : "0";
  };

  const getReminingValue = () => {
    const amountDue = parseFloat(getAmountDue() || 0);
    if (amountDue <= 0) return amountDue.toFixed(3);

    return input &&
      !isNaN(input) &&
      /^\d+(\.\d{1,2})?$/.test(input) &&
      parseFloat(input) <= amountDue
      ? (amountDue - parseFloat(input))?.toFixed(3)
      : "0";
  };

  const handlePaymentSubmit = async (type = "1") => {
    if (!selectedOrder) {
      toast.error("No order selected");
      return;
    }

    showLoader();
    try {
      const amountDue = parseFloat(getAmountDue());
      let paidAmount = parseFloat(input || amountDue);
      let pendingAmount = 0;
      let purchase_type = "1";

      // Payment type logic
      var paydata = {
        orderID: selectedOrder.order_id,
        date: getFormattedCurrentDate2(),
        amount: "0",
        total_amount: amountDue.toFixed(3),
        cash: 0,
        credit: 0,
        card: 0,
        type: 2, // Sales type
        mop: "0",
        complete: "0",
      };

      if (type == "1") { // Cash
        if (paidAmount < amountDue) {
          pendingAmount = (amountDue - paidAmount).toFixed(3);
          paydata.cash = paidAmount.toFixed(3);
          paydata.credit = pendingAmount;
          paydata.card = 0;
          paydata.mop = "1,2";
          purchase_type = "2";
        } else {
          paydata.cash = paidAmount.toFixed(3);
          paydata.credit = 0;
          paydata.card = 0;
          paydata.mop = "1";
          purchase_type = "1";
          paydata.complete = "1";
        }
      } else if (type == "2") { // Credit
        paidAmount = 0;
        pendingAmount = amountDue.toFixed(3);
        paydata.cash = 0;
        paydata.credit = pendingAmount;
        paydata.card = 0;
        paydata.mop = "2";
        purchase_type = "2";
      } else if (type == "4") { // Card
        if (paidAmount < amountDue) {
          pendingAmount = (amountDue - paidAmount).toFixed(3);
          paydata.cash = 0;
          paydata.credit = pendingAmount;
          paydata.card = paidAmount.toFixed(3);
          paydata.mop = "2,4";
          purchase_type = "2";
        } else {
          paydata.cash = 0;
          paydata.credit = 0;
          paydata.card = paidAmount.toFixed(3);
          paydata.mop = "4";
          purchase_type = "1";
          paydata.complete = "1";
        }
      } else if (type == "5") { // Cash+Card
        const cashVal = parseFloat(input || 0);
        const cardVal = Math.max(0, amountDue - cashVal);
        purchase_type = "1";
        paydata.complete = "1";
        // paydata.cash = paidAmount.toFixed(3);
        paydata.cash = cashVal.toFixed(3);
        paydata.card = cardVal.toFixed(3);
        paydata.credit = 0;
        // paydata.card = 0;
        // paydata.mop = "1";
        paydata.mop = cardVal > 0 ? "1,4" : "1";
        paidAmount = amountDue;
      }

      // Create payment record
      await onReqCreatePayment(paydata);

      // General ledger entries
      const generalDataBank = {
        type: "2",
        ref_id: selectedOrder.order_id,
        remarks: "Bank - From sales",
        date: getFormattedCurrentDate2(),
        created_by: UserItem?.user_id || "",
        shop_id: shopItem?.id || "0",
        amount: parseFloat(paidAmount).toString(),
        is_debit: "1",
      };
      await postGeneralData(generalDataBank);

      if (pendingAmount > 0) {
        const generalDataCredit = {
          type: "8",
          ref_id: selectedOrder.order_id,
          remarks: "Sales Credit",
          date: getFormattedCurrentDate2(),
          created_by: UserItem?.user_id || "",
          shop_id: shopItem?.id || "0",
          amount: pendingAmount,
          is_debit: "1",
          profitloss: "",
        };
        await postGeneralData(generalDataCredit);
      } else if (paydata?.complete === "1") {
        const paymentCompleted = {
          type: "8",
          shop_id: shopItem?.id || "0",
          ref_id: selectedOrder.order_id,
        };
        await UpdatePaymentComplete(paymentCompleted);
      }

      toast.success("Payment processed successfully");
      setCashShow(false);
      setCardShow(false);
      setCashCardShow(false);
      fetchOrders();
    } catch (error) {
      console.error("Error processing payment:", error);
      toast.error(error?.response?.data?.message || "Error processing payment");
    } finally {
      hideLoader();
    }
  };

  const handleOrderDataChange = (e) => {
    const { name, value } = e.target;
    setOrderData({
      ...orderData,
      [name]: value

    });

    if (errors[name]) {
      setErrors({ ...errors, [name]: '' });
    }
  };



  const handleItemChange = (index, field, value) => {
    let updatedItems = [...orderItems];
    updatedItems[index] = { ...updatedItems[index], [field]: value };

    // Auto-behavior based on free/paid
    if (field === "offer_type") {
      if (value === "free") {
        updatedItems[index].is_free = "1";
        updatedItems[index].offer_value = 0;
        updatedItems[index].remarks = "Free product";
        // updatedItems[index].sell_price = 0;
      } else {
        updatedItems[index].is_free = "0";
        updatedItems[index].remarks = "Normal sale";
      }
    }

    // If selecting a product → set price
    if (field === "pd_id") {
      const selectedProduct = products.find(p => p.id == value);
      if (selectedProduct) {
        updatedItems[index].sell_price = selectedProduct.p_price || selectedProduct.sell_price || 0;
      }
    }

    setOrderItems(updatedItems);
  };


  const addItemRow = () => {
    setOrderItems([
      ...orderItems,
      { pd_id: '', qty: 1, sell_price: '', offer_value: '', offer_type: '' }
    ]);
  };

  const removeItemRow = (index) => {
    if (orderItems.length === 1) {
      toast.warning("At least one product is required");
      return;
    }

    const updatedItems = [...orderItems];
    updatedItems.splice(index, 1);
    setOrderItems(updatedItems);
  };




  const validateOrder = () => {
    const newErrors = {};

    if (!orderData.customer_id) {
      newErrors.customer_id = "Customer selection is required";
    }

    if (!orderData.date) {
      newErrors.date = "Selling date is required";
    } else if (orderItems.length > 0) {
      const sellingDate = new Date(orderData.date);
      sellingDate.setHours(0, 0, 0, 0);

      orderItems.forEach((item) => {
        if (item.pd_id) {
          const product = products.find(p => p.id == item.pd_id);
          const targetMfgDate = product ? (product.mfg_date || product.create_date) : null;
          if (product && targetMfgDate) {
            const mfgDate = new Date(targetMfgDate);
            mfgDate.setHours(0, 0, 0, 0);

            if (sellingDate < mfgDate) {
              const day = String(mfgDate.getDate()).padStart(2, "0");
              const month = String(mfgDate.getMonth() + 1).padStart(2, "0");
              const year = mfgDate.getFullYear();
              const formattedMfgDate = `${day}/${month}/${year}`;
              newErrors.date = `Selling date cannot be earlier than manufactured date of ${product.product_title || 'selected product'} (${formattedMfgDate})`;
            }
          }
        }
      });
    }

    let hasQtyError = false;
    orderItems.forEach((item, index) => {
      if (!item.pd_id) {
        newErrors[`items_${index}_id`] = "Product selection is required";
      }
      if (!item.qty || parseFloat(item.qty) <= 0) {
        newErrors[`items_${index}_qty`] = "Valid quantity is required";
        hasQtyError = true;
      }
    });

    if (hasQtyError) {
      toast.error("Quantity must be greater than 0");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    if (!validateOrder()) return;

    showLoader();
    try {
      const formattedItems = orderItems.map(item => ({
        raw_mat_id: Number(item.pd_id),
        qty: Number(item.qty),
        price: Number(item.sell_price),
        remarks: item.is_free === "1" ? "Free raw material" : "Normal sale",
      }));

      let payload = {
        ...orderData,
        customer_id: orderData.customer_id === "walkin" ? "" : orderData.customer_id,
        items: formattedItems,
        tax_percent: parseFloat(taxPercent) || 0,
      };

      let response;

      if (isEditMode) {
        payload = {
          order_id: editOrder.order_id,
          admin_id: UserItem?.user_id || 1,
          customer_id: orderData.customer_id === "walkin" ? "" : orderData.customer_id,
          user_id: UserItem?.user_id || 1,
          shop_id: shopItem?.shop_id || 0,
          warehouse_id: selectedWarehouse?.id || 0,
          created_by: UserItem?.user_id || 1,
          items: formattedItems,
          date: orderData.date
        };

        response = await edit_raw_material_order(payload);
      } else {
        response = await create_raw_material_order(payload);
      }

      if (response.data?.status === "success") {
        toast.success(isEditMode ? "Order updated successfully" : "Order created successfully");

        resetForm();
        setShowOrderModal(false);
        setIsEditMode(false);

        fetchOrders();
      } else {
        toast.error(response.data?.message || "Failed to save order");
      }
    } catch (err) {
      toast.error("Error saving order");
    } finally {
      hideLoader();
    }
  };


  const resetForm = () => {
    setOrderData({
      admin_id: UserItem?.user_id || "",
      customer_id: "",
      user_id: UserItem?.user_id || "",
      shop_id: shopItem?.shop_id || "",
      ware_id: selectedWarehouse?.id || "",
      created_by: UserItem?.user_id || "",
      items: [],
      date: new Date().toISOString().split("T")[0]
    });
    setOrderItems([
      {
        pd_id: "",
        sell_price: "",
        qty: "",
        offer_value: "",
        offer_type: "amount",
      },
    ]);
    setTaxPercent(0);
    setErrors({});
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const m = moment(dateString);
      if (m.isValid()) {
        return m.format("DD/MM/YYYY");
      }
      const parts = String(dateString).split(/[-/T ]/);
      if (parts.length >= 3 && parts[0].length === 4) {
        return `${parts[2].padStart(2, '0')}/${parts[1].padStart(2, '0')}/${parts[0]}`;
      }
      return dateString;
    } catch (error) {
      return dateString;
    }
  };






  const orderStatusOptions = [
    { value: "0", label: "Pending" },
    { value: "1", label: "Waiting for Confirmation" },
    { value: "2", label: "Completed" },
    { value: "3", label: "Processing" },
    { value: "4", label: "Completed" },
    { value: "5", label: "Cancelled by User" },
    { value: "6", label: "Rejected by Admin" }
  ];
  const shouldShowStatusDropdown = (currentStatus) => {
    return !["4", "5", "6"].includes(currentStatus);
  };
  const getAvailableStatusOptions = (currentStatus) => {
    switch (currentStatus) {
      case "0": // Pending
        return [
          { value: "1", label: "Waiting for Confirmation" },
          { value: "3", label: "Processing" },
          { value: "4", label: "Completed" },
          { value: "6", label: "Reject Order" }
        ];
      case "1": // Waiting for Confirmation
        return [
          { value: "3", label: "Start Processing" },
          { value: "6", label: "Reject Order" }
        ];
      case "3": // Processing
        return [
          { value: "4", label: "Mark as Completed" },
          { value: "6", label: "Reject Order" }
        ];
      default:
        return [];
    }
  };

  const createFreeLedgerEntries = async (orderDbId, orderId, UserItem, shopItem, orderDate) => {
    // Dummy function - not applicable to raw materials
  };





  const updateOrderStatus = async (orderDbId, orderId, newStatus) => {
    showLoader();
    try {
      const order = ordersList.find(o => o.order_id === orderId || o.id === orderDbId);
      const orderDate = order?.date_time ? order.date_time.split("T")[0] : getFormattedCurrentDate2();

      if (newStatus === "4") {
        const response = await update_raw_material_order({
          order_id: orderId,
          status: newStatus,
          shop_id: shopItem?.shop_id || 0,
          warehouse_id: selectedWarehouse?.id || 0,
          branch_id: 1,
          created_by: UserItem?.user_id || 1,
        });

        if (response?.data && response?.data?.status == "success") {
          toast.success("Order marked as Completed");
          const total_order_price = response.data.overall_price;
          const total_order_mfg_price = response.data.total_mfg_price;

          if (total_order_price) {
            var paydata = {
              orderID: orderId,
              date: orderDate,
              amount: "0",
              total_amount: total_order_price.toFixed(3),
              cash: 0,
              credit: 0,
              card: 0,
              type: 2,
              mop: "2",
              complete: "0",
            };
            await onReqCreatePayment(paydata);

            const generalDataCredit = {
              type: "8",
              ref_id: orderId,
              remarks: "Sales Credit",
              date: orderDate,
              created_by: UserItem?.user_id || "ADMIN1",
              shop_id: shopItem?.id || "0",
              amount: total_order_price,
              is_debit: "1",
              profitloss: "",
            };
            await postGeneralData(generalDataCredit);
          }

          if (total_order_mfg_price) {
            const generalDataPayload = {
              type: "5",
              ref_id: orderId,
              remarks: "Sales Entry",
              date: orderDate,
              created_by: UserItem?.user_id || "ADMIN1",
              shop_id: shopItem?.id || "0",
              amount: total_order_price,
              is_debit: "0",
              profitloss: "",
            };
            await postGeneralData(generalDataPayload);

            const generalDataPayload1 = {
              type: "3", // RAW_MATERIAL_STOCKS
              ref_id: 'INV_' + orderId,
              remarks: "Raw material sales",
              date: orderDate,
              created_by: UserItem?.user_id || "ADMIN1",
              shop_id: shopItem?.id || "0",
              amount: total_order_mfg_price,
              is_debit: "0",
            };
            await postGeneralData(generalDataPayload1);

            const generalDataPayload2 = {
              type: "4", // COGS
              ref_id: 'COGS_' + orderId,
              remarks: "Inventory COGS",
              date: orderDate,
              created_by: UserItem?.user_id || "ADMIN1",
              shop_id: shopItem?.id || "0",
              amount: total_order_mfg_price,
              is_debit: "1",
            };
            await postGeneralData(generalDataPayload2);
          }
        } else {
          toast.error(response.data?.message || "Failed to update order status");
        }
      } else {
        const response = await Order_status_update({
          order_id: orderId,
          status: newStatus
        });

        if (response.data && response.data.status === "success") {
          const statusLabel = orderStatusOptions.find(opt => opt.value === newStatus)?.label;
          toast.success(`Order status updated to ${statusLabel}`);
        } else {
          toast.error(response.data?.message || "Failed to update order status");
        }
      }

      fetchOrders();

    } catch (error) {
      console.error("Error updating order status:", error);
      toast.error(error?.response?.data?.message || "Error updating order status");
    } finally {
      hideLoader();
    }
  };

  const fetchOrderDetails = async (orderId) => {
    showLoader();
    try {
      const res = await get_raw_material_order_details({ om_id: orderId });
      if (res?.data && res?.data?.status === "success") {
        setOrderDetails(res.data.data);
        setShowOrderDetailsModal(true);
      } else {
        toast.error("Failed to load order details");
      }
    } catch (err) {
      console.error("Error fetching order details:", err);
      toast.error("Error loading order details");
    } finally {
      hideLoader();
    }
  };


  const handleEditOrderClick = async (order) => {
    showLoader();
    try {
      setIsEditMode(true);
      setShowOrderModal(true);
      setSelectedOrderId(order.order_id);
      setEditOrder(order);

      const res = await get_raw_material_order_details({ om_id: order.id });
      const data = res?.data?.data;

      setOrderData({
        admin_id: UserItem?.user_id || "",
        customer_id: order.customer_id || "walkin",
        user_id: UserItem?.user_id || "",
        shop_id: shopItem?.shop_id || "",
        purchase_unit: orderData.purchase_unit || "2",
        warehouse_id: selectedWarehouse?.id || "",
        created_by: UserItem?.user_id || "",
        date: order.date_time ? order.date_time.split("T")[0] : new Date().toISOString().split("T")[0],
      });

      const formatted = data.map(i => ({
        pd_id: i.raw_mat_id,
        sell_price: i.price,
        qty: i.qty,
        offer_value: i.offer_value || 0,
        offer_type: "",
      }));

      setOrderItems(formatted);

    } catch (err) {
      toast.error("Failed to load order details");
    } finally {
      hideLoader();
    }
  };





  const handleEditItemChange = (index, key, value) => {
    const updated = [...editItems];
    updated[index][key] = value;
    setEditItems(updated);
  };
  const removeEditItemRow = (index) => {
    const updated = [...editItems];
    updated.splice(index, 1);
    setEditItems(updated);
  };



  const handleAddOrderClick = () => {
    setIsEditMode(false);
    resetForm();
    setShowOrderModal(true);
  };

  const calculateItemTotal = (item) => {
    const sellPrice = parseFloat(item.sell_price || 0);
    const qty = parseFloat(item.qty || 0);
    const offer = parseFloat(item.offer_value || 0);
    const offerType = item.offer_type || "";

    if (item.is_free === "1" || offerType === "free") return 0;

    let total = sellPrice * qty;

    if (offerType === "percent") {
      total -= (total * offer) / 100;
    } else if (offerType === "amount") {
      total -= offer;
    }

    return total < 0 ? 0 : total;
  };

  const subTotal = orderItems.reduce(
    (sum, item) => sum + calculateItemTotal(item),
    0
  );
  const taxAmount = (subTotal * (parseFloat(taxPercent) || 0)) / 100;
  const grandTotal = subTotal + taxAmount;




  return (
    <div className="page-wrappers">
      <div className="page-content">
        <NaviGate />
        <div className="mb-4 d-flex justify-content-between align-items-center bg-white p-3 rounded-2xl border border-slate-100 shadow-sm">
          <div className="text-start">
            <h3 className="mb-1 fw-bold text-slate-800 tracking-tight" style={{ fontSize: "24px" }}>Raw Material Orders</h3>
            <p className="text-sm text-slate-500 mb-0 font-medium">Record and manage raw material sales orders</p>
          </div>
          <div className="d-flex gap-2">
            <button
              type="button"
              className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 font-semibold text-sm"
              onClick={() => handleAddOrderClick()}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
              New Sales
            </button>
          </div>
        </div>

        <div className="card border-0 shadow-sm rounded-2xl">
          <div className="card-body p-4">
            <div className="table-responsive" style={{ minHeight: "280px" }}>
              <table
                className="table table-hover table-align-middle text-center mb-4"
                style={{ width: "100%", fontFamily: "Poppins" }}
              >
                <thead className="table-light">
                  <tr>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">No</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Order ID</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Customer</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Date</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Amount (INR)</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Payment Status</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Order Status</th>
                    <th className="py-2.5 text-xs font-bold text-slate-500 uppercase tracking-wider">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {ordersList.length > 0 ? (
                    ordersList.map((order, index) => (
                      <tr key={order.id} className="align-middle border-bottom border-slate-100">
                        <td className="text-sm font-semibold text-slate-700 py-3">{index + 1}</td>
                        <td className="text-sm font-semibold text-slate-700">{order.order_id}</td>
                        <td className="text-sm text-slate-600" style={{ maxWidth: "200px", whiteSpace: "normal", overflowWrap: "break-word" }}>{order.customer_name || `Walk-in Customer`}</td>
                        <td className="text-sm text-slate-600">{formatDate(order.date_time)}</td>
                        <td className="text-sm font-semibold text-slate-700">₹{(parseFloat(order.overall_price) || 0).toFixed(2)}</td>
                        <td className="text-sm text-slate-600">
                          {(() => {
                            const returnedAmt = getOrderReturnedAmount(order.order_id, order.id);
                            const remainingBal = Math.max(0, parseFloat(order.remaining || 0) - returnedAmt);
                            const isFullyReturned = returnedAmt > 0 && remainingBal === 0;

                            if (isFullyReturned) {
                              return (
                                <span className="badge px-2.5 py-1 text-xs font-bold uppercase rounded-full" style={{ backgroundColor: "#fef2f2", color: "#ef4444" }}>
                                  Returned
                                </span>
                              );
                            }

                            return (
                              <span className="badge px-2.5 py-1 text-xs font-bold uppercase rounded-full" style={{
                                backgroundColor: order.payments_status === "0" ? "#fff7ed" :
                                  order.payments_status === "1" ? "#eff6ff" :
                                    order.payments_status === "2" ? "#ecfdf5" : "#f1f5f9",
                                color: order.payments_status === "0" ? "#f97316" :
                                  order.payments_status === "1" ? "#3b82f6" :
                                    order.payments_status === "2" ? "#10b981" : "#475569"
                              }}>
                                {order.payments_status === "0" ? "Pending" :
                                  order.payments_status === "1" ? "Partial" :
                                    order.payments_status === "2" ? "Completed" : "Unknown"}
                              </span>
                            );
                          })()}
                        </td>
                        <td className="text-sm text-slate-600">
                          <span className="badge px-2.5 py-1 text-xs font-bold uppercase rounded-full" style={{
                            backgroundColor: order.status === "0" ? "#fff7ed" :
                              order.status === "1" ? "#fef08a" :
                                order.status === "2" || order.status === "4" ? "#ecfdf5" :
                                  order.status === "3" ? "#eff6ff" :
                                    order.status === "5" || order.status === "6" ? "#fef2f2" : "#f1f5f9",
                            color: order.status === "0" ? "#f97316" :
                              order.status === "1" ? "#a16207" :
                                order.status === "2" || order.status === "4" ? "#10b981" :
                                  order.status === "3" ? "#3b82f6" :
                                    order.status === "5" || order.status === "6" ? "#ef4444" : "#475569"
                          }}>
                            {orderStatusOptions.find(opt => opt.value === order.status)?.label || "Unknown"}
                          </span>
                        </td>
                        {/* <td>
                          <div className="d-flex justify-content-center align-items-center gap-3"> */}
                        <td className="px-1">
                          <div className="d-flex justify-content-center align-items-center gap-2 flex-wrap" style={{ minWidth: "150px" }}>

                            {/* VIEW ICON */}
                            <img
                              src="/assets/images/icons/view.png"
                              onClick={() => fetchOrderDetails(order.id)}
                              height="18px"
                              style={{ cursor: "pointer" }}
                            />

                            {["0", "1", "3"].includes(order.status) && (
                              <img
                                src="/assets/images/icons/edit.png"
                                onClick={() => handleEditOrderClick(order)}
                                height="18px"
                                style={{ cursor: "pointer" }}
                              />
                            )}

                            {order.status !== "4" && order.payments_status !== "2" && (
                              <i
                                className="bi bi-trash text-danger"
                                onClick={() => handleDeleteModal(order.id)}
                                style={{ cursor: "pointer", fontSize: "16px" }}
                                title="Delete Order"
                              ></i>
                            )}

                            {shouldShowStatusDropdown(order.status) && (
                              <div className="dropdown">
                                <button
                                  // className="btn btn-sm btn-outline-secondary dropdown-toggle"
                                  className="btn btn-sm btn-outline-secondary dropdown-toggle py-1 px-2.5"
                                  style={{ fontSize: "12px" }}
                                  type="button"
                                  id={`dropdownStatus-${order.id}`}
                                  data-bs-toggle="dropdown"
                                // data-bs-popper-config='{"strategy":"fixed"}'
                                >
                                  Update
                                </button>

                                <ul className="dropdown-menu" aria-labelledby={`dropdownStatus-${order.id}`}>
                                  {getAvailableStatusOptions(order.status).map((option) => (
                                    <li key={option.value}>
                                      <button
                                        className="dropdown-item"
                                        onClick={() => updateOrderStatus(order.id, order.order_id, option.value)}
                                      >
                                        {option.label}
                                      </button>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            {/* PAYMENT BUTTONS (Pay / Paid) */}
                            {order.status === "4" && (() => {
                              const returnedAmt = getOrderReturnedAmount(order.order_id, order.id);
                              const remainingBal = Math.max(0, parseFloat(order.remaining || 0) - returnedAmt);
                              const isFullyReturned = returnedAmt > 0 && remainingBal === 0;

                              if (isFullyReturned) {
                                return (
                                  // <button className="btn btn-success btn-sm px-3" title="Returned" disabled>
                                  <button
                                    className="btn btn-success btn-sm px-2.5 py-1"
                                    style={{ fontSize: "12px" }}
                                    title="Returned"
                                    disabled
                                  >
                                    Returned
                                  </button>
                                );
                              }

                              return (
                                <div>
                                  {remainingBal > 0 ? (
                                    <button
                                      // className="btn btn-warning btn-sm px-3"
                                      className="btn btn-warning btn-sm px-2.5 py-1"
                                      style={{ fontSize: "12px" }}
                                      onClick={() => openPaymentModal({ ...order, remaining: remainingBal })}
                                    >
                                      Pay
                                    </button>
                                  ) : (
                                    // <button className="btn btn-success btn-sm px-3" disabled>
                                    <button
                                      className="btn btn-success btn-sm px-2.5 py-1"
                                      style={{ fontSize: "12px" }}
                                      disabled
                                    >
                                      Paid
                                    </button>
                                  )}
                                </div>
                              );
                            })()}

                          </div>
                        </td>


                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No orders found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

            </div>
          </div>
        </div>

      </div>

      {/* Add / edit Order Modal */}
      {showOrderModal && (
        <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
          <div className="modal-dialog modal-xl model-center">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {isEditMode ? `Edit Raw Material Order (Order ID: ${selectedOrderId})` : "Create New Raw Material Order"}
                </h5>
                <button type="button" className="btn-close" onClick={() => {
                  resetForm();
                  setShowOrderModal(false)
                }}></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  {/* Customer Selection & Selling Date */}
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Select Customer <span className="text-danger">*</span></label>
                      <select
                        name="customer_id"
                        value={orderData.customer_id}
                        onChange={handleOrderDataChange}
                        className={`form-control ${errors.customer_id ? 'is-invalid' : ''}`}
                      >
                        <option value="">Select Customer</option>
                        <option value="walkin">Walk-in Customer</option>
                        {customers.map(customer => (
                          <option key={customer.customer_id} value={customer.customer_id}>
                            {customer.name}
                          </option>
                        ))}
                      </select>
                      {errors.customer_id && <div className="invalid-feedback">{errors.customer_id}</div>}
                    </div>
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Selling Date <span className="text-danger">*</span></label>
                      <FormattedDateInput
                        name="date"
                        value={orderData.date}
                        onChange={handleOrderDataChange}
                        className={errors.date ? 'is-invalid' : ''}
                      />
                      {errors.date && <div className="invalid-feedback d-block">{errors.date}</div>}
                    </div>
                  </div>


                  {/* Items Section */}
                  <div className="mt-4">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h6 className="mb-0">Order Items</h6>
                      <button type="button" className="btn btn-sm btn-primary" onClick={addItemRow}>
                        <i className="bi bi-plus"></i> Add Item
                      </button>
                    </div>

                    <div className="table-responsive">
                      <table className="table table-bordered align-middle">
                        <thead className="table-light">
                          <tr>
                            <th style={{ width: "5%", minWidth: "40px" }}>No</th>
                            <th style={{ width: "30%", minWidth: "180px" }}>Raw Material</th>
                            <th style={{ width: "15%", minWidth: "100px" }}>Sell Price / Unit</th>
                            <th style={{ width: "15%", minWidth: "90px" }}>Qty</th>
                            <th style={{ width: "15%", minWidth: "110px" }}>Offer</th>
                            <th style={{ width: "18%", minWidth: "100px" }}>Total</th>
                            <th style={{ width: "7%", minWidth: "50px" }}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orderItems.map((item, index) => {
                            console.log('item of raw material order items', item)
                            const product = products.find(p => p.id == item.pd_id);
                            const sellPrice = parseFloat(item.sell_price || product?.p_price || product?.sell_price || 0);
                            const qty = parseFloat(item.qty || 0);
                            const offer = parseFloat(item.offer_value || 0);
                            const offerType = item.offer_type || "amount";
                            const grandTotal = orderItems.reduce(
                              (sum, item) => sum + calculateItemTotal(item),
                              0
                            );


                            let total = sellPrice * qty;

                            if (offerType === "percent") {
                              total -= (total * offer) / 100;
                            } else if (offerType === "amount") {
                              total -= offer;
                            } else if (offerType === "free") {
                              total = 0;
                            }
                            if (total < 0) total = 0;
                            if (item.is_free === "1") {
                              total = 0;
                            }

                            return (
                              <tr key={index} className={item.pd_id ? "align-top" : "align-middle"}>
                                <td>{index + 1}</td>
                                <td>
                                  <select
                                    value={item.pd_id}
                                    onChange={(e) => {
                                      const productId = e.target.value;
                                      handleItemChange(index, "pd_id", productId);
                                    }}
                                    className={`form-control ${errors[`items_${index}_id`] ? 'is-invalid' : ''}`}
                                  >
                                    <option value="">Select Product</option>
                                    {products.map((product) => {
                                      // const isSelected = orderItems.some(
                                      //   (it, i) => it.pd_id == product.id && i !== index
                                      // );
                                      return (
                                        <option
                                          key={product.id}
                                          value={product.id}
                                        // disabled={isSelected}
                                        >
                                          {product.product_title} ({getUnitName(product.pbox_unit)})
                                          {/* {"_ Price :"}{product.p_price}  */}
                                        </option>
                                      );
                                    })}
                                  </select>

                                  {item.pd_id && (() => {
                                    const prod = products.find(p => p.id == item.pd_id);
                                    if (prod) {
                                      return (
                                        <div className="text-muted mt-1 small font-semibold" style={{ fontSize: "0.8rem" }}>
                                          Available Stock: <span className="text-primary fw-bold">{getProductStockDisplay(prod)}</span>
                                        </div>
                                      );
                                    }
                                    return null;
                                  })()}

                                  {errors[`items_${index}_id`] && (
                                    <div className="invalid-feedback">{errors[`items_${index}_id`]}</div>
                                  )}
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    // step="1"
                                    step="any"
                                    // value={item.sell_price || "0"}
                                    value={item.sell_price || 0}
                                    // value={item.offer_type === "free" ? 0 : item.sell_price || 0}
                                    // disabled={item.offer_type === "free"}
                                    // onChange={(e) => handleItemChange(index, 'sell_price', e.target.value)}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      // Allow clearing without forcing 0
                                      if (val === "") {
                                        handleItemChange(index, "sell_price", "0");
                                      } else {
                                        handleItemChange(index, "sell_price", Number(val));
                                      }
                                    }}
                                    onWheel={(e) => e.currentTarget.blur()}
                                    min={0}
                                    className="form-control"
                                    style={{ minWidth: "80px" }}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    min="0"
                                    step="any"
                                    value={item.qty}
                                    onChange={(e) => handleItemChange(index, 'qty', e.target.value)}
                                    onWheel={(e) => e.currentTarget.blur()}
                                    className="form-control"
                                    style={{ minWidth: "75px" }}
                                  />
                                </td>
                                <td>
                                  <div className="d-flex align-items-center">
                                    {/* <input
                                      type="number"
                                      min="0"
                                      step="0.01"
                                      value={item.offer_value || ""}
                                      onChange={(e) => handleItemChange(index, "offer_value", e.target.value)}
                                      className="form-control form-control-sm me-2"
                                      style={{ width: "90px", fontSize: "14px", textAlign: "right" }}
                                      placeholder="0.00"
                                    /> */}

                                    {/* <input
                                      type="number"
                                      min="0"
                                      step="0.01"
                                      value={item.offer_type === "free" ? 0 : item.offer_value || 0}
                                      disabled={item.offer_type === "free"}
                                      onChange={(e) => handleItemChange(index, "offer_value", e.target.value)}
                                      className="form-control form-control-sm me-2"
                                      style={{ width: "60px", fontSize: "14px", textAlign: "right" }}
                                      placeholder={item.offer_type === "free" ? "Free" : "0.00"}
                                    /> */}


                                    <select
                                      value={item.offer_type || "amount"}
                                      onChange={(e) => handleItemChange(index, "offer_type", e.target.value)}
                                      className="form-select form-select-sm"
                                      style={{
                                        width: "120px",
                                        // width: "75px",
                                        fontSize: "13px",
                                        textAlign: "center",
                                      }}
                                    >
                                      {/* <option value="amount">₹</option> */}
                                      {/* <option value="percent">%</option> */}

                                      <option value="">No Offer</option>
                                      <option value="free">Offer</option>
                                    </select>
                                  </div>
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    readOnly
                                    className="form-control-plaintext text-end"
                                    value={total.toFixed(2)}
                                  />
                                </td>
                                <td className="text-center">
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-danger"
                                    onClick={() => removeItemRow(index)}
                                  >
                                    <i className="bi bi-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                        <tfoot>
                          <tr>
                            <td colSpan="4"></td>
                            <td className="text-end fw-bold text-muted">Sub Total</td>
                            <td className="text-end fw-bold">
                              ₹ {subTotal.toFixed(2)}
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="4"></td>
                            <td className="text-end fw-bold">
                              GST
                              <input
                                type="number"
                                min="0"
                                max="100"
                                step="0.5"
                                value={taxPercent}
                                onChange={e => setTaxPercent(e.target.value)}
                                onWheel={(e) => e.currentTarget.blur()}
                                className="form-control form-control-sm d-inline-block ms-1"
                                style={{ width: "60px" }}
                              />
                              <span className="ms-1">%</span>
                            </td>
                            <td className="text-end fw-bold text-secondary">
                              ₹ {taxAmount.toFixed(2)}
                            </td>
                          </tr>
                          <tr className="table-primary">
                            <td colSpan="4"></td>
                            <td className="text-end fw-bold">Grand Total</td>
                            <td className="text-end fw-bold">
                              ₹ {grandTotal.toFixed(2)}
                            </td>
                          </tr>
                        </tfoot>

                      </table>
                    </div>
                  </div>

                  <div className="text-end mt-3">
                    <button type="button" className="btn btn-secondary me-2" onClick={() => { resetForm(); setShowOrderModal(false) }}>
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-primary">
                      {isEditMode ? "Update Order" : "Create Order"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Order Details Modal */}
      {
        showOrderDetailsModal && orderDetails && (
          <div className="modal fade show" style={{ display: "block" }} tabIndex="-1">
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Order Details</h5>
                  <button type="button" className="btn-close" onClick={() => setShowOrderDetailsModal(false)}></button>
                </div>
                <div className="modal-body">
                  {Array.isArray(orderDetails) && orderDetails.length > 0 && (
                    <div className="mt-3">
                      <h6>Order Information</h6>
                      <div className="row">
                        <div className="col-md-6">
                          <p>
                            <strong>Order ID:</strong> {orderDetails?.[0]?.order_id ?? "N/A"}
                          </p>
                          <p>
                            <strong>Customer Name:</strong> {orderDetails?.[0]?.customer_name || "Walk-in Customer"}
                          </p>
                          {/* <p><strong>Created By:</strong> {orderDetails?.[0]?.created_by ?? "N/A"}</p> */}
                        </div>

                        <div className="col-md-6 text-end">
                          <p>
                            <strong>Date:</strong> {orderDetails?.[0]?.date_time
                              ? formatDate(orderDetails[0].date_time)
                              : "N/A"}
                          </p>
                        </div>
                      </div>

                    </div>
                  )}

                  <h6 className="mb-3">Order Items</h6>
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Product</th>
                          <th>Quantity</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(orderDetails) && orderDetails.length > 0 ? (
                          orderDetails.map((item, index) => (
                            <tr key={item.raw_mat_id || index}>
                              <td>{index + 1}</td>
                              <td>{item.raw_material_title || `Raw Material #${item.raw_mat_id}`}</td>
                              <td>{item.qty}</td>
                              <td>₹{item.p_price}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="4" style={{ textAlign: 'center' }}>
                              No items found
                            </td>
                          </tr>
                        )}
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colSpan="3" className="text-end"><strong>Total Amount:</strong></td>
                          <td>
                            <strong>
                              ₹{
                                Array.isArray(orderDetails)
                                  ? orderDetails.reduce((sum, item) => sum + parseFloat(item.p_price || 0), 0).toFixed(2)
                                  : parseFloat(orderDetails?.p_price || 0).toFixed(2)
                              }
                            </strong>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>

                  <div className="text-end mt-3">
                    {selectedOrder && selectedOrder.status === "1" && selectedOrder.payments_status !== "2" && (
                      <button
                        type="button"
                        className="btn btn-success me-2"
                        onClick={() => openPaymentModal(selectedOrder)}
                      >
                        Process Payment
                      </button>
                    )}
                    <button type="button" className="btn btn-secondary" onClick={() => setShowOrderDetailsModal(false)}>
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }





      <div
        className="modal fade show"
        style={{ display: partialPaymentModal ? "block" : "none" }}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div
            className="modal-content p-3"
            style={{
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
            }}
          >
            {/* Modal Header */}
            <div className="modal-header border-0">
              <h5 className="modal-title fw-bold text-dark font-18">Payment</h5>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={() => setPartialPaymentModal(false)}
              ></button>
            </div>

            {/* Modal Body */}
            <div className="modal-body">
              <div className="p-3 bg-light rounded">
                <p className="mb-2 text-start">
                  Order ID: <span className="fw-bold">{selectedPaymentItem?.order_id}</span>
                </p>
                <p className="mb-2 text-start">
                  <span>Customer Name: </span>
                  <span className="fw-bold">{selectedPaymentItem?.customer_name || `Customer #${selectedPaymentItem?.customer_id}`}</span>
                </p>
                <hr />
                <div>
                  <p className="mb-2 d-flex justify-content-between">
                    <span>Amount:</span>
                    <span className="text-primary fw-bold">
                      {selectedPaymentItem?.overall_price}
                    </span>
                  </p>
                  <p className="mb-2 d-flex justify-content-between">
                    <span>Due Amount:</span>
                    <span className="text-danger fw-bold">
                      {selectedPaymentItem?.remaining || selectedPaymentItem?.overall_price || "0.00"}
                    </span>
                  </p>
                  <p className="mb-2 d-flex justify-content-between align-items-center">
                    <span>Cash:</span>
                    <input
                      type="number"
                      className="form-control text-end w-50"
                      value={cashAmount}
                      onChange={handleCashChange}
                      onWheel={(e) => e.currentTarget.blur()}
                      placeholder="0.00"
                    />
                  </p>
                  <p className="mb-2 d-flex justify-content-between align-items-center">
                    <span>Card:</span>
                    <input
                      type="number"
                      className="form-control text-end w-50"
                      value={cardAmount}
                      onChange={handleCardChange}
                      onWheel={(e) => e.currentTarget.blur()}
                      placeholder="0.00"
                    />
                  </p>
                </div>
                <hr />
                {/*   <p className="mb-0 fw-bold fs-6 text-end">
                  Total Payment:
                  <span className="text-primary ms-2">
                    {(parseFloat(cashAmount || 0) + parseFloat(cardAmount || 0)).toFixed(3)}
                  </span>
                </p>*/}
                <p className="mb-0 fw-bold fs-6 text-end">
                  Remaining Amount:
                  <span className="text-success fw-bold ms-2">
                    {Math.max(0,
                      parseFloat(selectedPaymentItem?.remaining || selectedPaymentItem?.overall_price || 0) -
                      parseFloat(cashAmount || 0) -
                      parseFloat(cardAmount || 0)
                    ).toFixed(3)}
                  </span>
                </p>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="modal-footer border-0 d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-secondary me-2"
                onClick={() => {
                  setPartialPaymentModal(false);
                  setCashAmount("");
                  setCardAmount("");
                }}
              >
                Cancel
              </button>
              <button
                className="btn btn-success"
                disabled={
                  (parseFloat(cashAmount || 0) + parseFloat(cardAmount || 0)) <= 0 ||
                  (parseFloat(cashAmount || 0) + parseFloat(cardAmount || 0)) >
                  parseFloat(selectedPaymentItem?.remaining || selectedPaymentItem?.overall_price || 0)
                }
                onClick={handleProcessPartialPayment}
              >
                Pay Now
              </button>
            </div>
          </div>
        </div>
      </div>

      <PaymentModal
        show={showPayModal}
        onClose={() => setShowPayModal(false)}
        onSelectPayment={handlePaymentType}
      />

      <CashModal
        show={cashShow}
        onClose={() => setCashShow(false)}
        input={input}
        setInput={setInput}
        getAmountDue={getAmountDue}
        getReturnValue={getReturnValue}
        getReminingValue={getReminingValue}
        handleClick={handleClick}
        handleBackspace={handleBackspace}
        handleSubmit={handlePaymentSubmit}
      />

      <CashCardModal
        show={cashCardShow}
        onClose={() => setCashCardShow(false)}
        input={input}
        setInput={setInput}
        getAmountDue={getAmountDue}
        getReturnValue={getReturnValue}
        getReminingValue={getReminingValue}
        handleClick={handleClick}
        handleBackspace={handleBackspace}
        handleSubmit={handlePaymentSubmit}
      />

      <CardModal
        show={cardShow}
        onClose={() => setCardShow(false)}
        input={input}
        setInput={setInput}
        getAmountDue={getAmountDue}
        getReturnValue={getReturnValue}
        getReminingValue={getReminingValue}
        handleClick={handleClick}
        handleBackspace={handleBackspace}
        handleSubmit={handlePaymentSubmit}
      />

      {showDeleteModal && (
        <Deletemodel
          setShowModal={setShowDeleteModal}
          handleDelete={handleDeleteOrder}
        />
      )}

    </div >
  );
};

export default RawMaterialOrder;

